export default function getsIgnoreCacheReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'GETS_CACHE_IGNORE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GETS_CACHE_IGNORE_ERROR':
            return {...state, ...{error: action.error}};

        case 'GETS_CACHE_IGNORE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}